/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import Button from "components/ButtonUse";
import EditIcon from "@mui/icons-material/Edit";
import useSWR from "swr";
import arrowimg from "../../assets/images/arrowimg.png";
// import style from '../manageCategory/category.css';
import "./category.css";
import DownloadIcon from "@mui/icons-material/Download";
import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";
import * as XLSX from "xlsx";
import DoneIcon from "@mui/icons-material/Done";
import bag from "./Image/bag.jpg";
import shoes from "./Image/shoes.jpg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import NoteAddIcon from "@mui/icons-material/Add";
// Dashboard components
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import LoaderComponent from "components/Loader";
import SnackBarComponent from "components/AlerComponent";
import { baseURL, baseUrl } from "utils/api";
import axios from "axios";
import ModalComponent from "components/ModalComponent";
import Select from "react-select";
import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

const catExcData=[{
  "_id": {
    "$oid": "65e2ba279bddcb7b2409a6f8"
  },
  "categoryName": "Woman",
  "subCategory": [
    {
      "categoryName": "accessories",
      "subCategory": [
        {
          "categoryName": "wallets",
          "subCategory": [],
          "_id": {
            "$oid": "65e2ba279bddcb7b2409a6fa"
          },
          "details": {
            "size": "l"
          }
        }
      ],
      "_id": {
        "$oid": "65e2ba279bddcb7b2409a6f9"
      }
    },
    {
      "categoryName": "clothing",
      "subCategory": [
        {
          "categoryName": "shirts",
          "subCategory": [],
          "_id": {
            "$oid": "65e2ba279bddcb7b2409a703"
          },
          "details": {
            "size": "xl"
          }
        }
      ],
      "_id": {
        "$oid": "65e2ba279bddcb7b2409a702"
      }
    },
    {
      "categoryName": "electronicc",
      "subCategory": [
        {
          "categoryName": "smartwathces",
          "subCategory": [
            {
              "categoryName": "abc",
              "subCategory": [
                {
                  "categoryName": "abc",
                  "subCategory": [],
                  "_id": {
                    "$oid": "65e2bb30718ecce550eab43b"
                  }
                }
              ],
              "_id": {
                "$oid": "65e2baead0a394f2449633c6"
              },
              "details": {
                "size": "xl"
              }
            }
          ],
          "_id": {
            "$oid": "65e2ba279bddcb7b2409a70b"
          },
          "details": {
            "size": "xl"
          }
        }
      ],
      "_id": {
        "$oid": "65e2ba279bddcb7b2409a70a"
      }
    }
  ],
  "__v": 4
},
{
  "_id": {
    "$oid": "65e2ba279bddcb7b2409a6fd"
  },
  "categoryName": "Men",
  "subCategory": [
    {
      "categoryName": "accessories",
      "subCategory": [
        {
          "categoryName": "wallets",
          "subCategory": [],
          "_id": {
            "$oid": "65e2ba279bddcb7b2409a6ff"
          },
          "details": {
            "size": "xl"
          }
        }
      ],
      "_id": {
        "$oid": "65e2ba279bddcb7b2409a6fe"
      }
    },
    {
      "categoryName": "clothing",
      "subCategory": [
        {
          "categoryName": "pants",
          "subCategory": [],
          "_id": {
            "$oid": "65e2ba279bddcb7b2409a707"
          },
          "details": {
            "size": "xl"
          }
        }
      ],
      "_id": {
        "$oid": "65e2ba279bddcb7b2409a706"
      }
    }
  ],
  "__v": 1
}];
function CategoryList() {
  const navigate = useNavigate();
  // fetch data swr
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  const [file, setFile] = useState("");
  const [showSnack, setShowSnack] = useState(false);
  const closeSnack = () => {
    setShowSnack(false);
  };
  // useEffect(() => {
  //   async function fetchData() {
  //     setLoading(true);
  //     const { data } = await axios.get(`${baseURL}/admin/fetch-categories`);
  //     setLoading(false);

  //     setData(data?.categories);
  //     //  console.log(data);
  //   }
  //   fetchData();
  // }, []);

  const [pinned, setPinned] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  };
  const handleSaveClick = async (id, categoryData) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteCategory = async (id) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/store/delete/${id}`);
      if (res.status === 200) {
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const fetchData = async (url) => {
  //   try {
  //     const response = await axios.get(url);
  //     return response.data;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // const { data, error } = useSWR(`${baseURL}/admin/fetch-categories`, fetchData, {
  //   refreshInterval: 1000
  // });
  // console.log(data, "data");

  // const handlePinCateory = async (id, value) => {
  //   try {
  //     // setPinned(true);
  //     setFormLoading(true);
  //     const res = await axios.post(`${baseURL}/admin/edit-category/${id}`, {
  //       pinned: value
  //     });
  //     if (res.status === 200) {
  //       console.log(res.data)
  //       setFormLoading(false);
  //     }
  //   } catch (error) {
  //     setFormLoading(false);

  //     console.log(error)
  //   }
  // }

  const [selectedTableRow, setSelectedRow] = useState(false);

  const columns = [
    {
      field: "index",
      headerName: "Sr No.",
      width: "80",
    },

    { field: "id", headerName: "ID", width: 150 },
    {
      field: "categoryName",
      headerName: "Category Name",
      width: 400,
    },

    // {
    //   field: "sortOrder",
    //   headerName: "Sort No.",
    //   width: 100,
    //   editable: true
    // },
    // {
    //   field: "pinned",
    //   headerName: "Pinned",
    //   width: 100,
    //   renderCell: (params) => {
    //     console.log(params)
    //     return (
    //       <>
    //         <input type="checkbox" checked={params.row.pinned} onChange={(e) => handlePinCateory(params.row.id, e.target.checked)} />
    //       </>
    //     )
    //   }
    //   // editable: true,
    // },
    {
      field: "categoryImage",
      headerName: "Image",
      width: 100,
      renderCell: (params) => (
        <>
          <div>
            <img
              src={
                params.row?.categoryImage ? params.row?.categoryImage : params.row.image.arrowimg
              }
              // alt={`User ${params.row.id}`}
              className="bg-" // Adjust styles as needed
            />
          </div>
        </>
      ),
    },
    // {
    //   field: "minimalWeight",
    //   headerName: "Min. Weight",
    //   width: 150,
    //   editable: true,
    // },
    // {
    //   field: "minimalSize",
    //   headerName: "Min. Size",
    //   width: 150,
    //   editable: true,
    // },
    // {
    //   field: "deliveryByTrain",
    //   headerName: "By Train",
    //   width: 100,
    //   editable: true,
    // },
    // {
    //   field: "deliveryByAir",
    //   headerName: "By Air",
    //   width: 100,
    //   editable: true,
    // },

    // {
    //   field: "percentageOfProfit",
    //   headerName: "Profit%",
    //   width: 100,
    //   editable: true,
    // },
    // {
    //   field: "bodyData",
    //   headerName: "isBodyData",
    //   width: 100,
    //   editable: true,
    // },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   description: "This column has a value getter and is not sortable.",
    //   sortable: false,
    //   width: 100,
    //   renderCell: (param) => {
    //     return (
    //       <>
    //         <div style={{ display: "flex", gap: "6px" }}>
    //           {/* <Tooltip
    //             onClick={() => navigate("/view_details", { state: product_obj })}
    //             title="view"
    //           >
    //             <IconButton>
    //               <MdOutlinePreview style={{ cursor: "pointer" }} />
    //             </IconButton>
    //           </Tooltip> */}
    //           <Tooltip onClick={() => navigate("/edit-category", { state: param.id })} title="Edit">
    //             <IconButton>
    //               <FaEdit className="text-blue-400" style={{ cursor: "pointer", }} />
    //             </IconButton>
    //           </Tooltip>
    //           <Tooltip onClick={() => handleDeleteCategory(param.id)} title="Delete">
    //             <IconButton>
    //               <MdDelete className="text-red-500" style={{ cursor: "pointer" }} />
    //             </IconButton>
    //           </Tooltip>
    //         </div>
    //       </>
    //     );
    //   },
    //   valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    // },
    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: "Quick Edit",
    //   width: 100,
    //   cellClassName: "actions",
    //   getActions: (params) => {
    //     const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

    //     if (isInEditMode) {
    //       return [
    //         <GridActionsCellItem
    //           icon={<SaveIcon />}
    //           label="Save"
    //           sx={{
    //             color: "green",
    //           }}
    //           onClick={() => {
    //             const rowWithoutImage = Object.entries(params.row).reduce((acc, [key, value]) => {
    //               if (key !== 'image') {
    //                 acc[key] = value;
    //               }
    //               return acc;
    //             }, {});
    //             console.log(rowWithoutImage)
    //             handleSaveClick(params.id, rowWithoutImage);
    //             // window.location.reload();
    //           }}
    //         />,
    //         <GridActionsCellItem
    //           icon={<CancelIcon />}
    //           label="Cancel"
    //           className="textPrimary"
    //           onClick={handleCancelClick(params.id)}
    //           color="inherit"
    //         />,
    //       ];
    //     }
    //     return [
    //       <GridActionsCellItem
    //         icon={<EditIcon className="text-blue-400" />}
    //         label="Edit"
    //         className="textPrimary"
    //         onClick={handleEditClick(params.id)}
    //         color="inherit"
    //       />,
    //     ];
    //   },
    //   valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    // },
  ];
  // const [updatedNewRow, setUpdatedRow] = useState(null);
  // const initialRows = data?.categories.map((mydata) => ({
  //   ...mydata,
  //   image: { arrowimg },
  // }));

  // console.log(initialRows);

  const [rows, setRows] = useState();
  const [rowModesModel, setRowModesModel] = useState({});
  const processRowUpdate = async (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    updatedRow(updatedRow);
    console.log(newRow);
    await handleDeleteCategory(newRow.id, newRow);
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

    return updatedRow;
  };

  const [allIds, setAllIds] = useState([]);

  const [formLoading, setFormLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);

    try {
      setFormLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/upload-category`, formData);
      console.log(res);
      if (res.status === 200) {
        setFormLoading(false);

        navigate("/");
      }
    } catch (error) {
      setFormLoading(false);

      console.log(error);
    }
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  // async function handleUpdateCategory(id, obj) {
  //   try {
  //     setFormLoading(true);

  //     const res = await axios.post(
  //       `${baseURL}/admin/edit-category/${id}`,
  //       {
  //         ...obj,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (res.status === 200) {
  //       setFormLoading(false);

  //     }
  //     setFormLoading(false);
  //   } catch (error) {
  //     setFormLoading(false);
  //     console.log(error);

  //   }
  // }
  const [users, setUser] = useState([]);

  const [enableSelection, setEnableSelection] = useState(false);

  const handleEnableSelection = () => {
    setEnableSelection(!enableSelection);
  };

  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((id) => initialRows.find((row) => row.id === id));
    const foundIds = selectedRowsData.map((d) => d.id);
    setAllIds(foundIds);
  };

  // const handleDeleteSelectedRows = async () => {
  //   let result = confirm("Are you sure you want to delete?");
  //   if (!result) {
  //     return;
  //   }
  //   try {

  //     setFormLoading(true);
  //     const res = await axios.post(`${baseURL}/admin/delete/categories`, {
  //       ids: allIds
  //     });
  //     setShowSnack(true);
  //     setFormLoading(false);
  //   } catch (error) {

  //     setFormLoading(false);
  //   }
  // }

  const [isOpen, setIsOpen] = useState(false); // State to manage dropdown visibility

  // Function to toggle dropdown visibility
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  //--------------------------------------ADD-ON POST-API--------------------------------------------------------------//

  const [categoryName, setCategoryName] = useState("");
  const [level, setLevel] = useState("");
  const handlePost = async (event) => {
    event.preventDefault();
    console.log(_id, "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    try {
      const details =
       { 
        categoryName:categoryName,
        parentId: parentCategory 
      };
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/categories/addCategoryHerirachy/`,
        {
          method: "POST",
          body: JSON.stringify(details),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        // Handle success response if needed
      } else {
        const error = await response.text();
        // Handle error response if needed
      }

      setCategoryName("");
      setLevel("");
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //--------------------------------------ADD-ON POST-API2--------------------------------------------------------------//
  const [categoryId, setCategoryId] = useState();

  const handlePostData = async (event) => {
    event.preventDefault();
    console.log(_id, "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    try {
      let details = { categoryName, level, caterogyId: "65b7899ff164aa84d5f05c68" }; 
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/categories/createCategories/`,
        {
          method: "POST",
          body: JSON.stringify(details),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        // Handle success response if needed
      } else {
        const error = await response.text();
        // Handle error response if needed
      }

      setCategoryName("");
      setLevel("");
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
    }
  };
  // ---------------------------------------------ADD-ON POST-API3------------------------------------------------------//
  const handlePostDatas = async (event) => {
    event.preventDefault();
    console.log(_id, "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    try {
      let details = { categoryName, level, caterogyId: "65b7899ff164aa84d5f05c6a" }; // Use categoryId here
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/categories/createCategories/`,
        {
          method: "POST",
          body: JSON.stringify(details),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        // Handle success response if needed
      } else {
        const error = await response.text();
        // Handle error response if needed
      }

      setCategoryName("");
      setLevel("");
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
    }
  };
  // ---------------------------------------------ADD-ON POST-API4------------------------------------------------------//
  const handlePostData4 = async (event) => {
    event.preventDefault();
    console.log(_id, "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    try {
      let details = { categoryName, level, caterogyId: "65b7899ff164aa84d5f05c73" }; // Use categoryId here
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/categories/createCategories/`,
        {
          method: "POST",
          body: JSON.stringify(details),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        // Handle success response if needed
      } else {
        const error = await response.text();
        // Handle error response if needed
      }

      setCategoryName("");
      setLevel("");
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // -----------------------------------------FIRST LEVEL---------------------------------------------//
  const [categories, setCategories] = useState([]);
  const [parentCategory, setParentCategory] = useState();
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/categories/getCategoriesListMain`,)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data.categories,'DATA')
        const categoryNames = data.categories.map((category) => category.categoryName);
        setCategories(data.categories);
        localStorage.setItem("data", JSON.stringify(categoryNames));
        localStorage.setItem("data", JSON.stringify(_id));
      })
      .catch((error) => {
        console.error("Error fetching data:", error.message);
      });
    // setCategories(catExcData);
  }, []);

  // -----------------------------LEVEL SECOND-----------------------------------------//
  const [_id, set_id] = useState("");
  const [categories1, setCategories1] = useState([]);
  const handleCategoryClick = (_id) => {
    // console.log(_id, "yyyyyyyyyyyyyyyyyyyyyy");
    setParentCategory(_id);

    fetch(`${process.env.REACT_APP_BASE_URL}/categories/subCategoriesV2?categoryId=${_id}&level=2`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Raw data from API:", data);
        setCategories1(data.result.categories);
        // localStorage.setItem('data', JSON.stringify(categoryNames));
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  // ---------------------------THIRD LEVEL-------------------------------------------------//
  const [categories2, setCategories2] = useState([]);

  const handleCategoryClicks = (_id) => {
    // console.log(_id, "yyyyyyyyyyyyyyyyyyyyyy");
    setParentCategory(_id);


    fetch(`${process.env.REACT_APP_BASE_URL}/categories/subCategoriesV2?categoryId=${_id}&level=3`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Raw data from API:", data);
        setCategories2(data.result.categories);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  // --------------------------------FOURTH LEVEL---------------------------------------------------//
  const [categories3, setCategories3] = useState([]);

  const handleCategoryClickss = (_id) => {
    // console.log(_id, "yyyyyyyyyyyyyyyyyyyyyy");
    setParentCategory(_id);


    fetch(`${process.env.REACT_APP_BASE_URL}/categories/subCategoriesV2?categoryId=${_id}&level=4`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Raw data from API:", data);
        setCategories3(data.result.categories);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  // ----------------SEARCHBAR--------LEVEL1-----------------------------------//
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCategories, setFilteredCategories] = useState([]);

  useEffect(() => {
    const filtered = categories.filter((category) =>
      category.categoryName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredCategories(filtered);
  }, [searchQuery, categories]);

  // Handle search query change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  // --------------------------SEARCHBAR------------------LEVEL-2----------------------------------------//
  const [searchQuery1, setSearchQuery1] = useState("");
  const [filteredcategories1, setFilteredCategories1] = useState([]);

  useEffect(() => {
    const filtered = categories1.filter((category) =>
      category.categoryName.toLowerCase().includes(searchQuery1.toLowerCase())
    );
    setFilteredCategories1(filtered);
  }, [searchQuery1, categories1]);

  // Handle search query change
  const handleChange = (e) => {
    setSearchQuery1(e.target.value);
  };
  // ----------------------------SEARCHBAR--------------------------LEVEL-3-------------------------------//
  const [searchQuery2, setSearchQuery2] = useState("");
  const [filteredcategories2, setFilteredCategories2] = useState([]);

  useEffect(() => {
    const filtered = categories2.filter((category) =>
      category.categoryName.toLowerCase().includes(searchQuery2.toLowerCase())
    );
    setFilteredCategories2(filtered);
  }, [searchQuery2, categories2]);

  // Handle search query change
  const handleSearch = (e) => {
    setSearchQuery2(e.target.value);
  };
  //-----------------------SEARCHBAR------------------------LEVEL-4---------------------------------------//
  const [searchQuery3, setSearchQuery3] = useState("");
  const [filteredcategories3, setFilteredCategories3] = useState([]);

  useEffect(() => {
    console.log(categories3,'categories33')
    const filtered = categories3?.filter((category) =>
      category.categoryName.toLowerCase().includes(searchQuery3.toLowerCase())
    );
    setFilteredCategories3(filtered);
  }, [searchQuery3, categories3]);

  // Handle search query change
  const handleSearchData = (e) => {
    setSearchQuery3(e.target.value);
  };

  // ----------------------------------------------------------------------------------------------------//
  const [showCategories, setShowCategories] = useState(true);

  const handleGoBack = () => {
    setShowCategories(!showCategories);
  };

  // ---------------------------------------ADD INPUT BOX-LEVEL-1------------------------------------------------------//
  const [showInputBox, setShowInputBox] = useState(false);
  const [addOnValue, setAddOnValue] = useState("");

  const handleAddOnClick = () => {
    setShowInputBox(true);
  };

  const handleInputChange = (e) => {
    setAddOnValue(e.target.value);
  };

  const handleAddOnSubmit = (e) => {
    e.preventDefault();
    console.log("Add-on value:", addOnValue);
    setShowInputBox(false);
    setAddOnValue("");
  };
  //-----------------------------------------------ADD INPUT- LEVEL-2----------------------------------------------------------//
  const [showInputBox1, setShowInputBox1] = useState(false);
  const [addOnValue1, setAddOnValue1] = useState("");

  const handleAddOnClick1 = () => {
    setShowInputBox1(true);
  };

  const handleInputChange1 = (e) => {
    setAddOnValue1(e.target.value);
  };

  const handleAddOnSubmit1 = (e) => {
    e.preventDefault();
    console.log("Add-on value:", addOnValue);
    setShowInputBox(false);
    setAddOnValue1("");
  };
  //-----------------------------------------------ADD INPUT- LEVEL-3----------------------------------------------------------//
  const [showInputBox2, setShowInputBox2] = useState(false);
  const [addOnValue2, setAddOnValue2] = useState("");

  const handleAddOnClick2 = () => {
    setShowInputBox2(true);
  };

  const handleInputChange2 = (e) => {
    setAddOnValue2(e.target.value);
  };

  const handleAddOnSubmit2 = (e) => {
    e.preventDefault();
    console.log("Add-on value:", addOnValue);
    setShowInputBox2(false);
    setAddOnValue2("");
  };
  // -------------------------------------ADD INPUT- LEVEL-4-----------------------------------------------------------//
  const [showInputBox3, setShowInputBox3] = useState(false);
  const [addOnValue3, setAddOnValue3] = useState("");

  const handleAddOnClick3 = () => {
    setShowInputBox3(true);
  };

  const handleInputChange3 = (e) => {
    setAddOnValue3(e.target.value);
  };

  const handleAddOnSubmit3 = (e) => {
    e.preventDefault();
    console.log("Add-on value:", addOnValue);
    setShowInputBox3(false);
    setAddOnValue3("");
  };

  //--------------------------------------------MORE OPTIONS--------------------------------------------------------//

  const handleSelectCategory = (categoryName) => {
    localStorage.setItem("selectedCategory", categoryName);
  };

  const handleSelectCategorys = (_id) => {
    localStorage.setItem("selectedCategory", _id);
  };
  //----------------------------------------------DONE-------------------------------------------------------//

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* {!data && <LoaderComponent open={true} />} */}
      {formLoading && <LoaderComponent open={true} />}
      <MDBox py={3}>
        {/* <div className="wrapper">
          <button className="bg-green-700 rounded-md w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white  text-sm" onClick={handleButtonClick}>
            Upload Excel File
          </button>
          <input type="file" accept=".xls,.xlsx" id="fileInput" style={{ display: 'none' }} onChange={handleFileChange} />
          {typeError && (
            <div className="alert alert-danger" role="alert">{typeError}</div>
          )}

          <div className="flex" style={{ marginTop: "-36px", marginLeft: "15%" }}>
            <label >
              <span onClick={() => navigate("/add-category")} type="button" className="bg-blue-700  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white">Upload Manually</span>
            </label>
          </div>

          {excelData && (
            <div className="viewer" style={{ marginTop: "3%" }}>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {excelData[0].map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}

                    </tr>

                  </thead>
                  <tbody>
                    {excelData.slice(1).map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex}>
                            {typeof cell === 'string' && cell.includes('<br>') ? (
                              cell.split('<br>').map((line, lineIndex) => (
                                <React.Fragment key={lineIndex}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))
                            ) : (
                              cell
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}


        </div> */}

        <div className="flex">
          {/* <label>
            <Link to="/HomeCategory">
              <span
                type="button"
                className="bg-blue-700  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
              >
                Home Categories
              </span>
            </Link>
          </label> */}

          {/* <div className="flex">
            <label>
              <Link to="/CategoriesList">
                <span
                  type="button"
                  className="bg-green-500  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Categories List
                </span>
              </Link>
            </label>
          </div> */}

          <div className="flex">
            <label>
              <Link to="/Categorydatalist">
                <span
                  type="button"
                  className="bg-purple-500  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Categories Details
                </span>
              </Link>
            </label>
          </div>
        </div>

        <Box sx={{ height: 320, width: "100%", background: "white", marginTop: "3%" }}>
          <div>
            {/* <div style={{ overflowY: 'auto', maxHeight: '300px' }}>
              <nav
                className="nav1"
              //  onMouseLeave={() => setShowCategories(false)}
              //  onMouseEnter={() => setShowCategories(true)}
              >
                <div>
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ width: '213px', marginLeft: '3%', borderRadius: '10px', padding: '5px' }}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  {filteredCategories.length > 0 ? (
                    <ul>
                      {filteredCategories.map((category, index) => (
                        <li key={index} style={{ fontSize: "12px" }}>
                          <a>
                            <Link to="/edit-category" style={{ marginLeft: "-20%" }}>
                              {category.categoryName}
                            </Link>
                            <span onClick={() => handleCategoryClick(category._id)} style={{ cursor: 'pointer' }}>
                              &rsaquo;
                            </span>
                          </a>
                          <hr />
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p style={{ fontSize: "20px", fontFamily: "serif", margin: "10%", color: "#006699" }}>Data is not available</p>
                  )}
                </div>

                <div className="flex" style={{ margin: "3%", marginTop: "25%" }}>
                  {!showInputBox ? (
                    <label>
                      <span
                        onClick={handleAddOnClick}
                        className="bg-green-500 rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                      >
                        <NoteAddIcon />
                        ADD ON
                      </span>
                    </label>
                  ) : (
                    <form >
                      <input style={{ width: "30%", marginTop: "10%" }}
                        type="text"
                        value={categoryName}
                        onChange={(e) => { setCategoryName(e.target.value) }}
                        placeholder="Enter add-on value"
                        className="p-2 border border-gray-300 rounded-md outline-none"
                      />
                       <input style={{ width: "30%", marginTop: "10%" }}
                        type="text"
                        value={categoryName}
                        onChange={(e) => { setCategoryName(e.target.value) }}
                        placeholder="Enter add-on value"
                        className="p-2 border border-gray-300 rounded-md outline-none"
                      />
                      
                      <button
                        style={{ padding: "3%" }}
                        type="submit"
                        className="bg-blue-500 rounded-md text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                        onClick={handlePost} 
                      >
                        Submit
                      </button>
                    </form>
                    
                  )}
                </div>
              </nav>

            </div> */}

            <div style={{ overflowY: "auto", maxHeight: "300px" }}>
              <nav className="nav1">
                <div>
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{
                      width: "202px",
                      marginLeft: "3%",
                      borderRadius: "10px",
                      padding: "5px",
                    }}
                  />
                </div>

                <div
                  style={{
                    overflowY: "auto",
                    maxHeight: "300px",
                    color: "red",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    marginLeft: "",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    {filteredCategories.length > 0 ? (
                      <ul>
                        {filteredCategories.map((category, index) => (
                          <li key={index} style={{ fontSize: "12px" }}>
                            <a>
                              {/* <Link to="/edit-category" style={{ marginLeft: "-20%" }}>
                                {category.categoryName}
                              </Link> */}
                              {console.log(category,'Category')}
                              <Link
                                to={{
                                  pathname: "/edit-category",
                                 
                                }}
                                state={{category: category,level:1 }}
                                style={{ marginLeft: "-20%" }}
                              >
                                {category.categoryName}
                              </Link>
                              <span
                                onClick={() => handleCategoryClick(category._id)}
                                style={{ cursor: "pointer" }}
                              >
                                &rsaquo;
                              </span>
                            </a>
                            <hr />
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p
                        style={{
                          fontSize: "20px",
                          fontFamily: "serif",
                          margin: "10%",
                          color: "#006699",
                        }}
                      >
                        Data is not available
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex" style={{ position: "" }}>
                  {!showInputBox ? (
                    <label>
                      <span
                        onClick={handleAddOnClick}
                        className="bg-blue-500 rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                      >
                        <NoteAddIcon />
                        ADD ON
                      </span>
                    </label>
                  ) : (
                    <form>
                      <input
                        style={{ width: "16%" }}
                        type="text"
                        value={categoryName}
                        onChange={(e) => {
                          setCategoryName(e.target.value);
                        }}
                        placeholder="Name.."
                        className="p-2 border border-gray-300 rounded-md outline-none"
                      />
                      <input
                        style={{ width: "16%", marginLeft: "5px" }}
                        type="text"
                        value={level}
                        onChange={(e) => {
                          setLevel(e.target.value);
                        }}
                        placeholder="Level.."
                        className="p-2 border border-gray-300 rounded-md outline-none"
                      />

                      <button
                        style={{ padding: "2%" }}
                        type="submit"
                        onClick={handlePost}
                        className="bg-blue-500 rounded-md text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                      >
                        Submit
                      </button>
                    </form>
                  )}
                </div>
              </nav>
            </div>

            <nav className="nav2">
              <div>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery1}
                  onChange={handleChange}
                  style={{ width: "202px", marginLeft: "3%", borderRadius: "10px", padding: "5px" }}
                />
              </div>

              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "300px",
                  color: "red",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  marginLeft: "",
                }}
              >
                <ul>
                  {categories1.length === 0 ? (
                    <li
                      style={{
                        fontSize: "20px",
                        fontFamily: "serif",
                        margin: "10%",
                        color: "#006699",
                      }}
                    >
                      Data is not available
                    </li>
                  ) : (
                    filteredcategories1.map((category, index) => (
                      <li key={index} style={{ fontSize: "12px" }}>
                        <a>
                          <Link to="/edit-category" state={{category:{_id:category._id}}} style={{ marginLeft: "-24%" }}>
                            {category.categoryName}
                          </Link>
                          <span
                            onClick={() => handleCategoryClicks(category._id)}
                            style={{ cursor: "pointer" }}
                          >
                            &rsaquo;
                          </span>
                        </a>
                        <hr />
                      </li>
                    ))
                  )}
                </ul>
              </div>
              <div className="flex" style={{ position: "fixed" }}>
                {!showInputBox1 ? (
                  <label>
                    <span
                      onClick={handlePost}
                      className="bg-blue-500 rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                    >
                      <NoteAddIcon />
                      ADD ON
                    </span>
                  </label>
                ) : (
                  <form>
                    <input
                      style={{ width: "16%" }}
                      type="text"
                      value={categoryName}
                      onChange={(e) => {
                        setCategoryName(e.target.value);
                      }}
                      placeholder="Name.."
                      className="p-2 border border-gray-300 rounded-md outline-none"
                    />

                    <input
                      style={{ width: "16%", marginLeft: "5px" }}
                      type="text"
                      value={level}
                      onChange={(e) => {
                        setLevel(e.target.value);
                      }}
                      placeholder="level.."
                      className="p-2 border border-gray-300 rounded-md outline-none"
                    />
                    <button
                      style={{ padding: "1%" }}
                      type="submit"
                      className="bg-blue-500 rounded-md text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                      onClick={handlePostData}
                    >
                      Submit
                    </button>
                  </form>
                )}
              </div>
            </nav>

            <nav className="nav3">
              <div>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery2}
                  onChange={handleSearch}
                  style={{ width: "220px", marginLeft: "3%", borderRadius: "10px", padding: "5px" }}
                />
              </div>

              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "300px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  marginLeft: "",
                }}
              >
                <ul>
                  {categories2.length === 0 ? (
                    <li
                      style={{
                        fontSize: "20px",
                        fontFamily: "serif",
                        margin: "10%",
                        color: "#006699",
                      }}
                    >
                      Data is not available
                    </li>
                  ) : (
                    filteredcategories2.map((category, index) => (
                      <li key={index} style={{ fontSize: "12px" }}>
                        <a>
                          <Link to="/edit-category" state={{category:{_id:category._id}}} style={{ marginLeft: "-24%" }}>
                            {category.categoryName}
                          </Link>
                          <span
                            onClick={() => handleCategoryClickss(category._id)}
                            style={{ cursor: "pointer" }}
                          >
                            &rsaquo;
                          </span>
                        </a>
                        <hr />
                      </li>
                    ))
                  )}
                </ul>
              </div>

              <div className="flex" style={{ position: "fixed" }}>
                {!showInputBox2 ? (
                  <label>
                    <span
                      onClick={handleAddOnClick2}
                      className="bg-blue-500 rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                    >
                      <NoteAddIcon />
                      ADD ON
                    </span>
                  </label>
                ) : (
                  <form onSubmit={handleAddOnSubmit2}>
                    <input
                      style={{ width: "16%", marginLeft: "15px" }}
                      type="text"
                      value={categoryName}
                      onChange={(e) => {
                        setCategoryName(e.target.value);
                      }}
                      placeholder="Name.."
                      className="p-2 border border-gray-300 rounded-md outline-none"
                    />
                    <input
                      style={{ width: "16%", marginLeft: "5px" }}
                      type="text"
                      value={level}
                      onChange={(e) => {
                        setLevel(e.target.value);
                      }}
                      placeholder="level.."
                      className="p-2 border border-gray-300 rounded-md outline-none"
                    />
                    <button
                      style={{ padding: "1%" }}
                      type="submit"
                      className="bg-blue-500 rounded-md text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                      onClick={handlePostDatas}
                    >
                      Submit
                    </button>
                  </form>
                )}
              </div>
            </nav>

            <nav className="nav4">
              <div>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery3}
                  onChange={handleSearchData}
                  style={{ width: "212px", marginLeft: "3%", borderRadius: "10px", padding: "5px" }}
                />
              </div>

              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "300px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  marginLeft: "",
                }}
              >
                <ul>
                  {categories3?.length === 0 ? (
                    <li
                      style={{
                        fontSize: "20px",
                        fontFamily: "serif",
                        margin: "10%",
                        color: "#006699",
                      }}
                    >
                      Data is not available
                    </li>
                  ) : (
                    filteredcategories3?.map((category, index) => (
                      <li key={index} style={{ fontSize: "12px" }}>
                        <a>
                          <Link to="/edit-category" state={{category:{_id:category._id}}} style={{ marginLeft: "-24%" }}>
                            {category.categoryName}{" "}
                            {/* <span onClick={toggleDropdown} style={{ cursor: "pointer" }}>
                              &rsaquo;
                            </span> */}
                          </Link>
                        </a>
                        <hr />
                      </li>
                    ))
                  )}
                </ul>
              </div>
              <div className="flex" style={{ position: "fixed" }}>
                {!showInputBox3 ? (
                  <label>
                    <span
                      onClick={handleAddOnClick3}
                      className="bg-blue-500 rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                    >
                      <NoteAddIcon />
                      ADD ON
                    </span>
                  </label>
                ) : (
                  <form onSubmit={handlePostData4}>
                    <input
                      style={{ width: "25%", marginLeft: "15px" }}
                      type="text"
                      value={categoryName}
                      onChange={(e) => setCategoryName(e.target.value)}
                      placeholder="Name.."
                      className="p-2 border border-gray-300 rounded-md outline-none"
                    />

                    <input
                      style={{ width: "25%", marginLeft: "5px" }}
                      type="text"
                      value={level}
                      onChange={(e) => setLevel(e.target.value)}
                      placeholder="level.."
                      className="p-2 border border-gray-300 rounded-md outline-none"
                    />
                    <button
                      style={{ padding: "2%" }}
                      type="submit"
                      className="bg-blue-500 rounded-md text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                    >
                      Submit
                    </button>
                  </form>
                )}
              </div>
            </nav>
          </div>
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CategoryList;
